import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Chip, makeStyles, TextField, Typography } from "@material-ui/core";
const useStyles = makeStyles(() => ({
  root: {
    "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
      // Default transform is "translate(14px, 20px) scale(1)""
      // This lines up the label with the initial cursor position in the input
      // after changing its padding-left.
      overflow: "hidden",
      "white-space": "nowrap",
      "text-overflow": "ellipsis",
      display: "inline-block",
      width: "70%",
      transform: "translate(14px, 20px) scale(1)",
      zIndex: 0,
    },
  },
  inputRoot: {},
  MuiAutocomplete: { paper: { "& ul": { maxHeight: "250px" } } },
  textField: {
    backgroundColor: "green",
    borderRadius: "0.35rem",
  },
}));

function CustomMultiSelectCoach(props: any) {
  console.log("props", props);
  const dataArr = [
    { title: "The Shawshank Redemption" },
    { title: "The Godfather" },
    { title: "The Godfather: Part II" },
  ];
  const fixedOptions = [dataArr[6]];
  const classes = useStyles();
  return (
    <Autocomplete
      multiple
      size='small'
      clearOnEscape
      id={props?.values.name}
      classes={classes}
      ref={props.ref}
      value={props?.defaultValue}
      options={props?.values.values}
      onChange={(event: any, newValue: any) => {
        // console.log("newValue", newValue)
        props.parentcall(newValue, props?.values);
      }}
      onInputChange={(event, newInputValue) => {
        // console.log("onInputChange", newInputValue)
        // props.parentcall(newInputValue, props?.values);
      }}
      renderTags={(selected) => {
        // console.log("selected = ", selected);
        let renderTagsValue = selected
          .map(function (elem: any) {
            return elem.title;
          })
          .join(", ");
        return (
          <Typography
            variant='h2'
            style={{ maxWidth: 360 }}
            noWrap={true}
            color='textPrimary'
          >
            {renderTagsValue}
          </Typography>
        );
      }}
      getOptionLabel={(option: any) => option.title}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          style={{ marginBlock: 10, backgroundColor: "white" }}
          label={props?.values.name}
          variant='outlined'
          className={classes.textField}
        />
      )}
    />
  );
}

export default CustomMultiSelectCoach;
